
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { isCampsiteDetailsRoute } from '../../../apps/pu-links/domain/Route'

@Component
export default class SearchSummaryBarLinkMatches extends Vue {
  @Prop({ required: false })
    slug?: string

  get isCampsitePage() {
    return isCampsiteDetailsRoute(this.$route)
  }

  get wizardPage() {
    const metaType = this.$route.meta.type
    return metaType && metaType === 'maps' ? 'searcheditmaps' : 'searchedit'
  }
}
